import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useTRPC } from '@/lib/trpc'

export function useActiveSessions() {
  const trpc = useTRPC()
  return useQuery(trpc.sessions.list.queryOptions())
}

export function useRevokeSession() {
  const trpc = useTRPC()
  const queryClient = useQueryClient()
  return useMutation(
    trpc.sessions.revoke.mutationOptions({
      // Ending your own session signs you out, which `me` then reports.
      onSettled: () =>
        Promise.all([
          queryClient.invalidateQueries(trpc.sessions.list.pathFilter()),
          queryClient.invalidateQueries(trpc.me.pathFilter())
        ])
    })
  )
}
